export default {
  'versionLog':	'Update log'
}
